module.exports = __webpack_public_path__ + "static/media/BG.6bfa8d4e.png";